// extracted by mini-css-extract-plugin
module.exports = {"styledBaseModal":"Modal-StyledBaseModal-module--styled-base-modal--1nEai"};